import {wordToUpperCase} from '@lemontree-ai/lemontree-admin-common-front/utils/stringUtils'

export function getDocumentElementPositon ( target ) {
  let result = { top:0, left:0 }
  if(target.offsetParent){
    while(target.offsetParent){
      result.top += target.offsetTop;
      result.left += target.offsetLeft;
      target = target.offsetParent
    }
  }
  return result;
}

export function getDocumentElementPopop ( target ) {
  let result = false;
  if(target.offsetParent){
    while(target != null){
      if(target.classList.contains('lemontree_layer')){
        result = true;
      }
      target = target.offsetParent;
    }
  }
  return result;
}

export function getDocumentParentElement ( target, parentId, parentClassName, tag ) {
  if(target.parentElement){
    while(target != null){

      const isIdSame = parentId ? target.id === parentId : true;
      const isClassNameSame = parentClassName && target.classList ? target.classList.contains(parentClassName) : true;
      const isTagSame = tag ? target.tagName === wordToUpperCase(tag) : true;

      if(isIdSame && isClassNameSame && isTagSame){
        return target
      }
      target = target.parentElement;
    }
  }
  return undefined;
}

export function setFitFontSize(wrap,base,max){
  let fontSize = max;
  const wrapH = wrap.offsetHeight;
  let baseH = base.offsetHeight;
  if(wrapH < baseH){
    while(wrapH <= baseH && fontSize > 0){
      fontSize -= 2;
      base.style.fontSize = fontSize+'px';
      baseH = base.offsetHeight;
    }
  }
  return fontSize;
}